import { Icons } from "../../../../../../utils/icons";
import img from "../../../../../assets/images/default_user.png";


const ProfileCard = ({ staffData }) => {
  return (
    <div className="flex flex-row justify-between items-center bg-white p-4 rounded-md">
      <div className="flex items-center flex-row gap-4">
        <div className="rounded-full overflow-hidden w-12 h-12 text-theme text-lg bg-light p-2 flexCenter">
          {/* <img src={img} alt="profile" /> */}
          {Icons.USER}
        </div>
        <span className="flex flex-col gap-0">
          <p className="text-lg font-semibold text-theme">{staffData?.name}</p>
          <p className="text-sm text-textLight">{staffData?.code} ({staffData?.username})</p>
        </span>
      </div>
    </div>
  );
};

export default ProfileCard;
